export default __webpack_public_path__ + "static/media/success.c9a75c53.gif";